






import { defineComponent } from 'vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';

export default defineComponent({
  components: { Icon },
  setup() {
    return { iconClassEnum };
  },
});
